export function extractApiErrorMessage(
  error: any,
  fallback = "Váratlan hiba történt."
): string {
  const responseMessage = error?.response?.data?.responseData?.responseMessage;
  const plainMessage = error?.message;

  if (Array.isArray(responseMessage)) {
    return responseMessage
      .map((item) => {
        if (typeof item === "string") return item;
        if (item?.error) return String(item.error);
        if (item?.message) return String(item.message);
        return "";
      })
      .filter(Boolean)
      .join("\n");
  }

  if (typeof responseMessage === "string" && responseMessage.trim()) {
    return responseMessage;
  }

  if (typeof plainMessage === "string" && plainMessage.trim()) {
    return plainMessage;
  }

  return fallback;
}

export function normalizeMultilineText(value: unknown): string[] {
  return String(value || "")
    .replace(/<br\s*\/?>/gi, "\n")
    .split("\n")
    .map((line) => line.trim())
    .filter(Boolean);
}
